import React, { useState } from 'react';
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import {
    downloadDocumentMedia,
    isDocumentMediaPath,
} from 'src/mtska-frontend-data-provider/redux/downloadDocumentMedia';

const CellUrl = ({ value, type = 'simple' }) => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const documentMediaPath = isDocumentMediaPath(value);

    const handleDocumentMediaClick = async (event) => {
        event.preventDefault();
        if (loading) {
            return;
        }

        setLoading(true);
        setError(null);
        try {
            await downloadDocumentMedia(value);
        } catch (err) {
            setError(err?.message || t('Unable to download file.'));
        } finally {
            setLoading(false);
        }
    };

    if (documentMediaPath) {
        return (
            <Box className={"list-element-cell cell-" + type}>
                <a
                    href="#"
                    onClick={handleDocumentMediaClick}
                    style={{ cursor: loading ? 'wait' : 'pointer' }}
                    aria-busy={loading}
                >
                    {value}
                </a>
                {error && (
                    <Box component="span" sx={{ display: 'block', color: 'danger.500', fontSize: 'sm' }}>
                        {error}
                    </Box>
                )}
            </Box>
        );
    }

    return (
        <Box className={"list-element-cell cell-" + type}>
            <a href={value} rel="noreferrer" target="_blank">{value}</a>
        </Box>
    );
};

export default CellUrl;
